import { render, staticRenderFns } from "./ShowAnnouncement2.vue?vue&type=template&id=238682b0&scoped=true&"
import script from "./ShowAnnouncement2.vue?vue&type=script&lang=js&"
export * from "./ShowAnnouncement2.vue?vue&type=script&lang=js&"
import style0 from "./ShowAnnouncement2.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ShowAnnouncement2.vue?vue&type=style&index=1&id=238682b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238682b0",
  null
  
)

export default component.exports